export const PHYSICAL_RUN_ID_PATTERN =
  /^physical-[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/u;

export function exactPhysicalRunId(value: unknown): string {
  if (typeof value !== "string" || !PHYSICAL_RUN_ID_PATTERN.test(value)) {
    throw new Error(`Physical run ID is not canonical: ${String(value)}`);
  }
  return value;
}
